import { Schema } from "@effect/schema";
import { Percent } from "../percent";

export type MarketUserState = typeof MarketUserState.Type;
export type MarketUserStateEncoded = typeof MarketUserState.Encoded;

export const MarketUserState = Schema.Struct({
  userLtv: Percent,
  userLiquidationThreshold: Percent,
  healthFactor: Percent,
  borrowingPowerUsed: Percent,
  isAtRiskOfLiquidation: Schema.Boolean,
}).annotations({ identifier: "MarketUserState" });
